import React from 'react';
import {SensitivePackageSearchData} from "./SensitivePackageSearchData";
import FiltersDataContextProvider from "../../commons/context/FiltersDataContext";
import FiltersStateContextProvider from '../../commons/context/FiltersStateContext';
import ViewDataContextProvider from "../../commons/context/view/ViewDataContext.js";

const SensitivePackageSearchView = (props) => {

        return (
            <FiltersDataContextProvider>
              <FiltersStateContextProvider context = {props.match.params.context}>
              <ViewDataContextProvider>
                <SensitivePackageSearchData history={props.history} location={props.location}/>
              </ViewDataContextProvider>
              </FiltersStateContextProvider>   
            </FiltersDataContextProvider>
        )
}

export default SensitivePackageSearchView;


// WEBPACK FOOTER //
// ./src/components/packageList/SensitivePackageSearchView.js